// extracted by mini-css-extract-plugin
export default {"body":"authSuperAdmin_body__BmhMv","card":"authSuperAdmin_card__oRgg8","logo":"authSuperAdmin_logo__3iDmM","button":"authSuperAdmin_button__gEyV5"};